import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RatingsService {

  constructor(
    private readonly apollo: Apollo
  ) {}

  async getRatingsByQuantity(where): Promise<any> {
    return await this.apollo
      .query<any>({
        query: gql`
          query accountRatingsCountQuery($where: DashboardRatingsWhereInput!) {
            accountRatingsCount(where: $where) {
              reportName
              item {
                oneStarCount
                twoStarsCount
                threeStarsCount
                fourStarsCount
                fiveStarsCount
              }
            }
          }
        `,
        variables: {
          where: where
        }
      })
      .toPromise()
      .then((result) => result.data.accountRatingsCount.item);
  }

  async getAccountRatingsAverageByTimeline(interval, where): Promise<any> {

    return await this.apollo
      .query<any>({
        query: gql`
          query accountRatingsAverageByTimeline($where: DashboardRatingsByTimelineWhereInput!) {
            accountRatingsAverageByTimeline(where: $where) {
            reportName
            items {
              totalCount
              completedAt
              averageRating
            }
          }
        }`,
        variables: {
          where: {
            interval: interval,
            companyId_in: where.companyId_in,
            segmentId_in: where.segmentId_in,
            locationId_in: where.locationId_in,
            locationGroupId_in: where.locationGroupId_in,
            maintenanceTypeId_in: where.maintenanceTypeId_in
          }
        }
      })
      .toPromise()
      .then((result) => {
        const mappedItems = result.data.accountRatingsAverageByTimeline.items.map((item) => {
          const { averageRating, ...rest } = item;
          return { ...rest, average: averageRating };
        });
        return {
          ...result.data.accountRatingsAverageByTimeline,
          items: mappedItems
        };
      });
  }

  async accountRatingsAverageLineChart(where): Promise<any> {
    return await this.apollo
      .query<any>({
        query: gql`
          query accountRatingsAverageLineChart($where: DashboardRatingsLineChartWhere!) {
            accountRatingsAverageLineChart(where: $where) {
            reportName
            items {
              totalCount
              completedAt
              averageRating
            }
          }
        }`,
        variables: {
          where: {
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            companyId_in: where.companyId_in,
            segmentId_in: where.segmentId_in,
            locationId_in: where.locationId_in,
            locationGroupId_in: where.locationGroupId_in,
            maintenanceTypeId_in: where.maintenanceTypeId_in,
            completedAt_gte: where.completedAt_gte,
            completedAt_lte: where.completedAt_lte
          }
        }
      })
      .toPromise()
      .then(({ data }) => {
        data.accountRatingsAverageLineChart.items = data.accountRatingsAverageLineChart.items.map((item) => {
          const { completedAt: date, averageRating: value, ...rest } = item;
          return { date, value, ...rest };
        });

        return data;
      });
  }

  async getRatedTasks({ where, orderBy, ratingIn }): Promise<any> {

    return await this.apollo
      .query<any>({
        query: gql`
          query accountRatingsTasksQuery($where: DashboardRatingsTasksWhereInput!, $orderBy: DashboardRatingsTasksOrderByInput!) {
            accountRatingsTasks(where: $where, orderBy: $orderBy) {
              reportName
              items {
                id
                ratingStars
                maintenance {
                  id
                  number
                  location {
                    id
                    name
                  }
                  company {
                    name
                  }
                }
              }
            }
          }
        `,
        variables: {
          orderBy: orderBy,
          where: {
            rating_in: ratingIn,
            completedAt_gte: where.completedAt_gte,
            completedAt_lte: where.completedAt_lte,
            companyId_in: where.companyId_in,
            segmentId_in: where.segmentId_in,
            locationId_in: where.locationId_in,
            locationGroupId_in: where.locationGroupId_in,
            maintenanceTypeId_in: where.maintenanceTypeId_in
          }
        }
      })
      .toPromise()
      .then((result) => result.data.accountRatingsTasks);
  }
}
